export function getPasswordErrors(password: string): string[] {
  const errors = [];

  if (password.length < 12) {
    errors.push("forms.error.password.length");
  }

  return errors;
}
